module.exports = __webpack_public_path__ + "img/195-a4fa23.png";